import { render, staticRenderFns } from "./DepartmentShow.vue?vue&type=template&id=66b5e839&scoped=true&"
import script from "./DepartmentShow.vue?vue&type=script&lang=ts&"
export * from "./DepartmentShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b5e839",
  null
  
)

export default component.exports